import { ApiConnector, DELETE, GET, POST, PUT } from './requestV2.service';

export default (() => {
    const API = ApiConnector('/quizzes', true);
    return {
        ActiveQuizzes: async query => await API(GET, `/${query}`).call(),
        GetResult: async (data, query) => await API(POST, `/confirm/${query}`).call(data),
        GetHistory: async () => await API(GET, '/history').call(),
        GetQuizStatistic: async (data, query) => await API(GET, '/statistics', false, query).call(data),
        GetQuizStatisticTeacher: async (data, query) => await API(GET, `/statistics`, false, query).call(data),
        GetQuizStatisticSingle: async (data, query) => {
            const { quizze_id, ...params } = query;
            return await API(GET, `/statistics/${quizze_id}`, false, params).call(data);
        },
        CreateQuiz: async data => await API(POST, '/create').call(data),
        UpdateQuiz: async (id, data) => await API(POST, `/${id}`).call(data),
        GetQuizBossList: async (data, query) => await API(GET, `/all`, false, query).call(data),
        GetQuizBoss: async id => await API(GET, `/single/${id}`).call(),
        UpdateQuizBoss: async (id, data) => await API(PUT, `/${id}`).call(data),
        DeleteQuiz: async id => await API(DELETE, `/${id}`).call(),
        DeleteQuestion: async id => await API(DELETE, `/question/${id}`).call(),
    };
})();
